export function isBlank(s) {
    return s == null || (s.trim() === '');
}
export function isNotBlank(s) {
    return isBlank(s) === false;
}
//# sourceMappingURL=string.js.map